import img0 from "./Assets/0.png";
import img1 from "./Assets/1.png";
import img2 from "./Assets/2.png";
import img3 from "./Assets/3.png";
import img4 from "./Assets/4.png";
import img5 from "./Assets/5.png";
import img6 from "./Assets/6.png";
import img7 from "./Assets/7.png";
import img8 from "./Assets/8.png";
import logo from "./Assets/bs.png";

export default class BrightStarConfig {
    constructor() {
        // Set up the symbol imgs & Logo
        // Make sure to match with imports above
        this.symbolImgs = [img0, img1, img2, img3, img4, img5, img6, img7, img8];
        this.logo = logo;

        //Game Name
        this.name = "Bright Star";

        //General Config
        this.reels = 3;
        this.symbolPerReel = 3;
        this.cascade = false;

        //This is used to invert the symbol IDs (because Aris). Input the highest symbol ID possible in the game.
        //Have left this to be a manual input as sometimes it can work slightly differently depending on game
        this.highestSymId = 0;

        //Ask CROW for the maths object
        this.maths = this.getMaths();
    }

    getMaths() {
        //paste what crow gives you here!
        return {
            94:{
                reductionWeight1M : 12741
            },
            95: {
                weights: {
                    Base: [1],
                    freeSpins: {
                        f: [1]
                    },
                },
                reelSets: {
                    0: [
                        [7, 5, 4, 7, 5, 6, 7, 7, 2, 5, 7, 3, 5, 7, 5, 1, 7, 6, 7, 5, 7, 2, 7, 5, 7, 5, 7, 3, 5, 7, 7, 1, 5, 7, 3, 5, 5, 7, 2, 7, 5, 4, 7, 3, 5, 7, 3, 5, 7, 5, 3, 7, 1, 5, 7, 5, 5, 7],
                        [6, 4, 6, 7, 4, 6, 4, 5, 6, 6, 4, 6, 6, 4, 3, 6, 4, 4, 6, 7, 4, 2, 6, 4, 2, 6, 4, 6, 5, 4, 6, 2, 4, 6, 6, 0, 0, 0, 6, 1, 4, 6, 2, 4, 6, 4, 6, 1, 6, 4, 2, 6, 4, 6, 4],
                        [7, 4, 6, 5, 4, 6, 7, 3, 5, 7, 6, 2, 1, 7, 3, 6, 4, 7, 6, 6, 7, 5, 6, 6, 1, 7, 6, 4, 3, 7, 2, 6, 6, 4, 7, 5, 3, 6, 7, 4, 6],
                    ],
                    f_0: [
                        [1, 4, 2, 6, 3, 4, 5, 2, 4, 2, 7, 3, 6, 1, 3, 2, 7, 3, 6, 2, 5, 3, 4, 1, 7, 5],
                        [8, 8, 8, 8, 8],
                        [1, 4, 2, 1, 6, 3, 5, 1, 4, 2, 7, 3, 6, 7, 4, 5, 2, 3, 6, 2, 5, 3, 4, 1, 7, 5],
                    ],
                },
            },
        };
    }
}
